import {
  ValidationFacebookId,
  ValidationInstagramId,
  ValidationLengthUnder10,
  ValidationLengthUnder100,
  ValidationLengthUnder20,
  ValidationLengthUnder254,
  ValidationLengthUnder255,
  ValidationLengthUnder4,
  ValidationLengthUnder50,
  ValidationLengthUnder500,
  ValidationLengthUnder60,
  ValidationLineId,
  ValidationPostNum1,
  ValidationPostNum2,
  ValidationTel,
  ValidationTwitterId,
} from '..';
import { ValidationDatePicker } from '../validation-date-picker';
import { ValidationNotEmpty } from '../validation-not-empty';
import { ValidationNumberLengthUnder3 } from '../validation-number-length-under';
import { ValidationMailAddressEmptyOk } from '../validation-mail-address-empty-ok';
import { CustomerEditState } from '../../../type/customer/customer.type';
import { ValidationLengthUnderHankaku60 } from '../validation-length-under-hankaku60';

export const CustomerValidation = (data: CustomerEditState) => {
  window.console.log(data);
  return (
    // 必須
    !data.employee_id
    || !data.name
    || !data.post_no[0]
    || !data.post_no[1]
    || !data.prefecture
    || !data.city
    || !data.address
    // バリデーション
    || ValidationLengthUnder60.filter((v) => !v.run(String(data.name || ''))).length
    || ValidationLengthUnder10.filter((v) => !v.run(String(data.keisho || ''))).length
    || ValidationLengthUnder60.filter((v) => !v.run(String(data.furigana || ''))).length
    || ValidationPostNum1.filter((v) => !v.run(String(data.post_no[0] || ''))).length
    || ValidationPostNum2.filter((v) => !v.run(String(data.post_no[1] || ''))).length
    || ValidationMailAddressEmptyOk.filter((v) => !v.run(String(data.mail_address || ''))).length
    || ValidationLengthUnder254.filter((v) => !v.run(String(data.mail_address || ''))).length
    || ValidationLengthUnder255.filter((v) => !v.run(String(data.city || ''))).length
    || ValidationLengthUnder255.filter((v) => !v.run(String(data.address || ''))).length
    || ValidationLengthUnder255.filter((v) => !v.run(String(data.building_name || ''))).length
    || ValidationTel.filter((v) => !v.run(String(data.tel_no || ''))).length
    || ValidationTel.filter((v) => !v.run(String(data.fax_no || ''))).length
    || ValidationTel.filter((v) => !v.run(String(data.tel_no2 || ''))).length
    || ValidationTel.filter((v) => !v.run(String(data.tel_no3 || ''))).length
    || ValidationMailAddressEmptyOk.filter((v) => !v.run(String(data.mail_address2 || ''))).length
    || ValidationLengthUnder254.filter((v) => !v.run(String(data.mail_address2 || ''))).length
    || ValidationMailAddressEmptyOk.filter((v) => !v.run(String(data.mail_address3 || ''))).length
    || ValidationLengthUnder254.filter((v) => !v.run(String(data.mail_address3 || ''))).length
    || ValidationLineId.filter((v) => !v.run(String(data.line_id || ''))).length
    || ValidationFacebookId.filter((v) => !v.run(String(data.facebook_id || ''))).length
    || ValidationTwitterId.filter((v) => !v.run(String(data.twitter_id || ''))).length
    || ValidationInstagramId.filter((v) => !v.run(String(data.instagram_id || ''))).length
    || ValidationDatePicker.filter((v) => !v.run(String(data.construction_info || ''))).length
    || ValidationLengthUnder500.filter((v) => !v.run(String(data.remarks || ''))).length
    || ValidationLengthUnder255.filter((v) => !v.run(String(data.memo1 || ''))).length
    || ValidationLengthUnder255.filter((v) => !v.run(String(data.memo2 || ''))).length
    || ValidationLengthUnder20.filter((v) => !v.run(String(data.my_car_type_other || ''))).length
    || ValidationLengthUnder20.filter((v) => !v.run(String(data.tag_list_other || ''))).length
    || ValidationLengthUnder60.filter((v) => !v.run(String(data.introducer || ''))).length
    || ValidationDatePicker.filter((v) => !v.run(String(data.wedding_anniversary || ''))).length
  );
};
